var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgJobTitle = function SvgJobTitle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17 9.222a3.12 3.12 0 0 0-3.111-3.111h-.778v-.778A2.292 2.292 0 0 0 10.778 3H9.222a2.292 2.292 0 0 0-2.333 2.333v.778h-.778A3.12 3.12 0 0 0 3 9.222v4.667A3.12 3.12 0 0 0 6.111 17h7.778A3.12 3.12 0 0 0 17 13.889zM8.444 5.333a.735.735 0 0 1 .778-.778h1.556a.735.735 0 0 1 .778.778v.778H8.444zM4.556 9.222a1.56 1.56 0 0 1 1.555-1.555h7.778a1.56 1.56 0 0 1 1.556 1.556V10H4.556zm9.333 6.222H6.111a1.56 1.56 0 0 1-1.556-1.556v-2.332h3.889v.233a1.394 1.394 0 0 0 1.4 1.4h.389a1.394 1.394 0 0 0 1.4-1.4v-.233h3.889v2.333a1.684 1.684 0 0 1-1.633 1.555z",
    transform: "translate(-3 -3)",
    style: {
      fill: "#a0a0a0"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJobTitle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jobTitle.3bcb674e.svg";
export { ForwardRef as ReactComponent };